(function () {

    'use strict';
    angular.module('iplusjs.validator.email', [
        'iplusjs.utils.format'
    ])
    .directive('iplusjsEmailValidator', emailValidator);

    emailValidator.$inject = [
        'FormatUtilsService'
    ];
    function emailValidator(FormatUtilsService) {
        return {
            require: 'ngModel',
            link: function ($scope, $elem, $attrs, $ngModel) {
                $ngModel.$validators.email = function (modelValue, viewValue) {
                    return $ngModel.$isEmpty(viewValue) || FormatUtilsService.regexEmail.test(viewValue);
                };

                $ngModel.$validators.emailUmlaute = function (modelValue, viewValue) {
                    return $ngModel.$isEmpty(viewValue) || !/[äöüß]/gi.test(viewValue);
                };
            }
        };
    }
})();
